import { Component } from '@angular/core';

import { ModalHelpComponent } from '../modals/modal-help/modal-help.component';
import { ModalsService } from '../modals/modals.service';

@Component({
  standalone: false,
  selector: 'pptl-help-button',
  templateUrl: 'help-button.component.html',
  styleUrls: ['help-button.component.scss'],
})
export class HelpButtonComponent {
  constructor(private modalsService: ModalsService) {}

  async onHelpClick() {
    this.modalsService.showModal({ component: ModalHelpComponent, cssClass: 'modal-help' });
  }
}
